import {
  ProviderResourcesCollapsibleContainerConnected,
  useGetClientHasTherapyToolkitEnabled,
} from "@grow-therapy-team/seedling-components";
import { useAtomValue } from "jotai";
import {
  inSessionPatientInformationAtom,
  isSelectedClientUserMinorAtom,
  isSelectedPatientEnrolledInStructuredCareProgram,
  providerShortIdAtom,
  selectedClientUserShortIdAtom,
} from "../state";

export function ProviderResourcesCollapsibleContainerWrapper() {
  const clientUserShortId = useAtomValue(selectedClientUserShortIdAtom) ?? "";
  const providerShortId = useAtomValue(providerShortIdAtom) ?? "";
  const appointmentShortId =
    useAtomValue(inSessionPatientInformationAtom)
      ?.inSessionAppointmentShortId ?? undefined;
  const { data: clientHasTherapyToolkitEnabledData } =
    useGetClientHasTherapyToolkitEnabled(clientUserShortId);
  const isTherapyToolkitFeatureEnabled =
    clientHasTherapyToolkitEnabledData?.clientHasTherapyToolkitEnabled;
  const isPatientEnrolledInStructuredCareProgram = useAtomValue(
    isSelectedPatientEnrolledInStructuredCareProgram,
  );
  const isClientUserMinor = useAtomValue(isSelectedClientUserMinorAtom);
  if (!isTherapyToolkitFeatureEnabled) return null;

  return (
    <ProviderResourcesCollapsibleContainerConnected
      clientUserShortId={clientUserShortId}
      providerShortId={providerShortId}
      isHidden={isClientUserMinor}
      isPatientEnrolledInStructuredCareProgram={
        isPatientEnrolledInStructuredCareProgram
      }
      appointmentShortId={appointmentShortId}
    />
  );
}
